import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { Frame } from '../components/Frame';
import { Provider } from '../components/Provider';
import { Byline } from '../../common/Byline';
import { ActionList } from '../components/ActionList';
import { Content } from '../components/Content';
import { messages } from '../../../messages';
import { ContentHeader } from '../components/ContentHeader';
import { ContentFooter } from '../components/ContentFooter';
import { handleClickCommon } from '../utils/handlers';
import { Link } from '../components/Link';
const textBylineProps = {
  ...messages.connect_link_account_card_description
};
export const UnauthorizedView = ({
  context = {
    text: ''
  },
  isSelected = false,
  actions = [],
  testId = 'block-card-unauthorized-view',
  actionOptions,
  link = '',
  onClick = () => {}
}) => {
  const handleClick = event => handleClickCommon(event, onClick);
  return jsx(Frame, {
    isSelected: isSelected,
    testId: testId,
    isFluidHeight: true
  }, jsx(Content, {
    isCompact: true
  }, jsx("div", null, jsx(ContentHeader, {
    onClick: handleClick,
    link: link
  }, jsx(Link, {
    url: link,
    testId: testId
  })), jsx(Byline, {
    testId: testId ? `${testId}-byline` : undefined,
    text: jsx(FormattedMessage, _extends({}, textBylineProps, {
      values: {
        context: context.text
      }
    }))
  })), jsx(ContentFooter, null, jsx(Provider, {
    name: context.text,
    icon: context.icon
  }), !(actionOptions !== null && actionOptions !== void 0 && actionOptions.hide) && jsx(ActionList, {
    items: actions
  }))));
};